import script from "./AuthModeLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthModeLink.vue?vue&type=script&setup=true&lang=ts"

import "./AuthModeLink.vue?vue&type=style&index=0&id=755fc868&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755fc868"]])

export default __exports__